module.exports = __webpack_public_path__ + "img/img_digitalisierung_03.80140006.jpg";